import {inject, Injectable} from '@angular/core';
import {UserService} from './user.service';

@Injectable({ providedIn: 'root' })
export class AuthService {

  userService: UserService = inject(UserService);

  isLoggedIn(): boolean {
    return this.userService.isLogged();
  }

}
